import { forwardRef } from 'react';
import { AnimatedSpinner } from '../AnimatedSpinner';
import { UploadIcon } from '../Icons';

interface IFileInputProps {
  isFileUploading: boolean;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleTouchEnd?: () => void;
}

const FileInput = forwardRef<HTMLInputElement, IFileInputProps>(
  ({ isFileUploading, handleFileChange, handleTouchEnd = () => {} }, ref) => {
    return (
      <div
        onTouchEnd={handleTouchEnd}
        className="tc-waveform-icon align-middle tc-dark-grey-bg tc-waveform-upload upload-container text-white">
        {!isFileUploading ? (
          <label className="w-full flex items-center justify-center h-full cursor-pointer">
            <input
              ref={ref}
              type="file"
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept="image/jpeg, image/png, application/pdf"
            />
            <UploadIcon />
          </label>
        ) : (
          <span className="cursor-default">
            <AnimatedSpinner />
          </span>
        )}
      </div>
    );
  },
);

export { FileInput };
